import { Link, useLocation } from "react-router-dom";
// Use <img src="/asset/logos/logo.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/av.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/dm.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/sm.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/vp.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/image.webp" /> in JSX instead of import
// Use <img src="/asset/NewIcons/dm.webp" /> in JSX instead of import
// Use <img src="/asset/icons/hamburger1.svg" /> in JSX instead of import
// Use <img src="/asset/icons/chevron-down.svg" /> in JSX instead of import
import {
  FaFacebook,
  FaWhatsapp,
  FaLinkedin,
  FaInstagram,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Navbar = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { locale, toggleLocale, setLocale } = useLanguage();

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleServices = () => setIsServicesOpen(!isServicesOpen);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHomePage = location.pathname === "/";

  const navLinkStyle = `font-body text-lg transition-colors duration-300 ${
    isHomePage && !isScrolled ? "text-white" : "text-green-700"
  } hover:text-green-800`;

  const socialIconStyle = `text-xl transition-colors duration-300 ${
    isHomePage && !isScrolled ? "text-white" : "text-green-800"
  } hover:text-green-800`;
  const t = {
    fr: {
      home: "Accueil",
      services: "Formations",
      about: "À propos",
      faq: "FAQ",
      contact: "Contact",
      blog: "Blog",
      followUs: "Suivez-nous",
      langShort: "FR",
    },
    en: {
      home: "Home",
      services: "Programs",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      blog: "Blog",
      followUs: "Follow us",
      langShort: "EN",
    },
  }[locale || "fr"]; 

  const services = [
    {
      to: "/SecretariatMedical",
      icon: "/asset/NewIcons/av.webp",
      title: locale === "en" ? "Medical Secretary" : "Secrétariat Médical",
      desc:
        locale === "en"
          ? "Comprehensive training in medical records management and patient reception"
          : "Formation complète en gestion des dossiers médicaux et accueil des patients",
    },
    {
      to: "/AuxiliaireDeVie",
      icon: "/asset/NewIcons/dm.webp",
      title: locale === "en" ? "Care Assistant" : "Auxiliaire de Vie",
      desc:
        locale === "en"
          ? "Training in support care and assistance for dependent people"
          : "Formation aux soins d'accompagnement et soutien aux personnes dépendantes",
    },
    {
      to: "/DelegueMedical",
      icon: "/asset/NewIcons/sm.webp",
      title: locale === "en" ? "Medical Delegate" : "Délégué Médical",
      desc:
        locale === "en"
          ? "Training in medical visits and pharmaceutical representation"
          : "Formation en visite médicale et représentation pharmaceutique",
    },
    {
      to: "/AssistantEnCabinetMedical",
      icon: "/asset/NewIcons/vp.webp",
      title:
        locale === "en" ? "Assistant in Medical Practice" : "Assistant en Cabinet Médical",
      desc:
        locale === "en"
          ? "Learning techniques for assisting healthcare professionals"
          : "Apprentissage des techniques d'assistance aux professionnels de santé",
    },
    {
      to: "/VendeurPharmacie",
      icon: "/asset/NewIcons/image.webp",
      title: locale === "en" ? "Pharmacy Salesperson" : "Vendeur en Pharmacie",
      desc:
        locale === "en"
          ? "Training in pharmaceutical dispensing and customer advice"
          : "Formation en dispensation pharmaceutique et conseil client",
    },
    {
      to: "/AgentTechniqueLaboratoire",
      icon: "/asset/NewIcons/dm.webp",
      title: locale === "en" ? "Laboratory Technician" : "Agent Technique Laboratoire",
      desc:
        locale === "en"
          ? "Specialization in neonatal care and child development"
          : "Spécialisation en soins néonatals et développement de l'enfant",
    },
  ];

  const socialLinks = [
    {
      icon: FaFacebook,
      url: "https://web.facebook.com/profile.php?id=61574957061667",
    },
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/itc_sante_cameroun?igsh=MTF1aGVyZmNyNTN3YQ==",
    },
    {
      icon: FaLinkedin,
      url: "https://www.linkedin.com/company/itc-santé/?viewAsMember=true",
    },
    {
      icon: FaTiktok,
      url: "https://www.tiktok.com/@itcsant3?_t=ZS-8vbgt98kamd&_r=1",
    },
    { icon: FaWhatsapp, url: "https://wa.me/237651245653" },
    { icon: FaYoutube, url: "https://youtube.com/@laminutesante-h5t?si=iGkT-Dv0wnkuIu2a" },
  ];

  return (
    <nav
      className={`${
        isScrolled || !isHomePage
          ? "sticky bg-white shadow-md"
          : "absolute bg-transparent"
      } z-50 w-full px-12 py-4 top-0 flex justify-between items-center transition-colors duration-300 max-sm:px-6`}
    >
      <Link to="/">
        <img
          src="/asset/logos/logo.webp"
          alt="ITC Santé"
          className="h-24 w-auto hover:opacity-80 transition-opacity"
        />
      </Link>
     

      {/* Desktop Navigation */}
      <div className="hidden md:flex w-full items-center justify-between">
       
        {/* Centered Menu */}
        <div className="flex items-center justify-center flex-1 space-x-6">
          <Link to="/" className={navLinkStyle}>
            {t.home}
          </Link>
          {/* Services Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            <div
              className={`${navLinkStyle} group flex items-center gap-1 cursor-pointer`}
            >
              <span>{t.services}</span>
              <img
                src="/asset/icons/chevron-down.svg"
                alt="dropdown"
                className="w-4 mt-1 transition-transform group-hover:rotate-180"
              />
            </div>
            <div
              className={`
        absolute top-10 left-0 bg-white rounded-xl shadow-lg p-4 w-[500px] z-50
        transition-all duration-300 ease-out
        ${
          isServicesOpen
            ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
            : "opacity-0 scale-95 -translate-y-2 pointer-events-none"
        }
      `}
              style={{ boxShadow: "0 8px 32px rgba(166, 198, 118, 0.12)" }}
            >
              <div className="grid grid-cols-2 gap-4">
                {services.map(({ to, icon, title, desc }) => (
                  <Link
                    key={to}
                    to={to}
                    className="flex gap-3 items-start p-3 rounded-xl transition-colors duration-200 hover:bg-green-100 group"
                  >
                    <img src={icon} alt={title} className="w-6 pt-1" />
                    <div>
                      <h3 className="font-bold text-green-800 group-hover:text-yellow-400 transition-colors duration-200">
                        {title}
                      </h3>
                      <p className="opacity-60 text-sm">{desc}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <Link to="/about" className={navLinkStyle}>
            {t.about}
          </Link>
          <Link to="/faq" className={navLinkStyle}>
            {t.faq}
          </Link>
          <Link to="/contact" className={navLinkStyle}>
            {t.contact}
          </Link>
          <Link to="/blog" className={navLinkStyle}>
            {t.blog}
          </Link>
        </div>
        {/* Social Icons and Language at right end */}
        <div className="flex items-center gap-4">
          <button
            onClick={toggleLocale}
            className={`px-3 py-1 rounded border transition-colors ${
              isHomePage && !isScrolled ? "text-white border-white" : "text-green-800 border-green-800"
            } hover:bg-green-100 hover:text-green-800`}
            aria-label="toggle language"
            title={locale === "fr" ? "Français" : "English"}
          >
            {t.langShort}
          </button>
          {socialLinks.map(({ icon: Icon, url }, index) => (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={socialIconStyle}
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMenu}
        className="md:hidden hover:filter bg-green-800 hover:brightness-90 transition-all"
      >
        <img
          src="/asset/icons/hamburger1.svg"
          alt="menu"
          className="h-8"
          style={{
            filter: isHomePage && !isScrolled ? "invert(100%)" : "none",
          }}
        />
      </button>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-white z-50 p-6 flex flex-col">
          <Link
            to="/"
            className="text-lg font-bold text-green-800 mb-4"
            onClick={toggleMenu}
          >
            {t.home}
          </Link>

          {/* Dropdown Formations Mobile */}
          <div>
            <button
              className="flex justify-between items-center text-green-800 font-semibold text-lg mb-2 w-full"
              onClick={toggleServices}
            >
              <span>{t.services}</span>
              <img
                src="/asset/icons/chevron-down.svg"
                alt="toggle"
                className={`w-4 transform transition-transform ${
                  isServicesOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            {isServicesOpen && (
              <div className="ml-4 space-y-2">
                {services.map(({ to, title }) => (
                  <Link
                    key={to}
                    to={to}
                    onClick={toggleMenu}
                    className="text-gray-700 hover:text-green-800 block py-2"
                  >
                    {title}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/about"
            className="text-green-800 hover:text-green-600 mt-4 font-semibold py-2"
            onClick={toggleMenu}
          >
            {t.about}
          </Link>
          <Link
            to="/faq"
            className="text-green-800 hover:text-green-600 mt-2 font-semibold py-2"
            onClick={toggleMenu}
          >
            {t.faq}
          </Link>
          <Link
            to="/contact"
            className="text-green-800 hover:text-green-600 mt-2 font-semibold py-2"
            onClick={toggleMenu}
          >
            {t.contact}
          </Link>
          <Link
            to="/blog"
            className="text-green-800 hover:text-green-600 mt-2 font-semibold py-2"
            onClick={toggleMenu}
          >
            {t.blog}
          </Link>

          <div className="mt-auto pt-6 border-t border-gray-200">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-green-800">{t.followUs}</h3>
              <div>
                <button
                  onClick={() => setLocale("fr")}
                  className={`px-3 py-1 mr-2 rounded border text-green-800 border-green-800 ${
                    locale === "fr" ? "bg-green-100" : ""
                  }`}
                >
                  FR
                </button>
                <button
                  onClick={() => setLocale("en")}
                  className={`px-3 py-1 rounded border text-green-800 border-green-800 ${
                    locale === "en" ? "bg-green-100" : ""
                  }`}
                >
                  EN
                </button>
              </div>
            </div>
            <div className="flex gap-4">
              {socialLinks.map(({ icon: Icon, url }, index) => (
                <a
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-green-800 hover:text-green-600 transition-colors text-2xl"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
